






import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { IWizard } from "../../../../../domain/format";
import { DocumentEditableMixin, CommonComponentsAccessibleMixin } from "../../mixins";

@Component
export default class DocumentEditNavigator extends Mixins(DocumentEditableMixin, CommonComponentsAccessibleMixin) {
  @Prop()
  wizard: IWizard;

  @Prop()
  authenticate: (isForcibly: boolean) => Promise<boolean>;

  @Prop()
  isLastPageAlreadyAccessed: boolean;

  get isRegisterable(): boolean {
    return this.wizard
        && this.isLastPageAlreadyAccessed
        && Array.isArray(this.wizard.pages)
        && Enumerable.from(this.wizard.pages).all(p => p.isRegisterable(this.editingSource.source));
  }

  get isTemporary(): boolean {
    return this.wizard
      && this.wizard.registration
      && this.wizard.registration.isTemporary;
  }

  get shouldAuthenticate(): boolean {
    return this.wizard
      && this.wizard.registration
      && this.wizard.registration.shouldAuthenticate;
  }

  async registerDocument(): Promise<void> {
    if (!await this.authenticate(this.shouldAuthenticate)) {
      return; // キャンセル.
    }
    if (this.isTemporary) {
      await this.commonComponents.operators.registerer.registerDocumentAsTemporary(true, true);
    } else {
      await this.commonComponents.operators.registerer.registerDocument(true);
    }
  }
}
